import React from 'react';
import "../../styles/styles.scss";

class SecondRadioButtonsGroup extends React.Component {


    replyClickSec = (event) => {
        let clickedId = event.currentTarget.getAttribute("data-id");
        let dv = document.querySelectorAll(".wrappersec")[0];  
        let lightboxDiv = document.querySelector(".fotoGridSec div");
        let clicked = document.getElementsByClassName(clickedId);
        
        for (let i=0; i < clicked.length; i+=1) {
                clicked[i].classList.remove("nonselected");
                clicked[i].setAttribute("data-attribute", "SRL");
                lightboxDiv.appendChild(clicked[i]);
        }      
        
        let children = lightboxDiv.getElementsByTagName('a');
        let listitems = [];
        for (let k = 0; k < children.length; k++) {
                listitems.push(children.item(k));
            }
            listitems.sort(function(a, b) {
                var compA = Number(a.getAttribute('data-indx'));
                var compB = Number(b.getAttribute('data-indx'));
                return ((compA < compB) ? -1 : (compA > compB) ? 1 : 0);
            });
        for (let m = 0; m < listitems.length; m++) {
            lightboxDiv.appendChild(listitems[m]);
        }

        const notClicked = document.querySelectorAll(`.allYear:not(.${clickedId})`);
        for (let i=0; i < notClicked.length; i+=1) {
            notClicked[i].classList.add("nonselected");
            notClicked[i].removeAttribute("data-attribute");
            dv.appendChild(notClicked[i]);
        }
        let radio = document.querySelector(`#${clickedId} .radio`);
        const notRadio = document.querySelectorAll(`.radioButton:not(#${clickedId}) .radio`);
        radio.style.background = "var(--secondary-color)";
        for (let j=0; j < notRadio.length; j+=1) {
            notRadio[j].style.background = "var(--primary-color)";
        }
}

render() {
        return (
            <form className={`selectionButtonsGroup`}>
                <div className="radioButton" id="allYear" data-id="allYear" role = "button" tabIndex='0' onKeyDown={(event) => this.replyClickSec(event)} onClick={(event) => this.replyClickSec(event)}>
                    <div className="radio" ></div>
                        <label htmlFor="allYear">
                            <span>Wszystkie</span>
                        </label>
                </div>
                <div className="radioButton" id="spring" data-id="spring" role = "button" tabIndex='0' onKeyDown={(event) => this.replyClickSec(event)} onClick={(event) => this.replyClickSec(event)}>
                    <div className="radio" ></div>
                        <label htmlFor="spring">
                            <span>Wiosna</span>
                        </label>
                </div>
                <div className="radioButton" id="summer" data-id="summer" role = "button" tabIndex='0' onKeyDown={(event) => this.replyClickSec(event)} onClick={(event) => this.replyClickSec(event)}>
                    <div className="radio" ></div>
                        <label htmlFor="summer">
                            <span>Lato</span>
                        </label>
                </div>
                <div className="radioButton" id="fall" data-id="fall" role = "button" tabIndex='0' onKeyDown={(event) => this.replyClickSec(event)} onClick={(event) => this.replyClickSec(event)}>
                    <div className="radio" ></div>
                        <label htmlFor="fall">
                            <span>Jesień</span>
                        </label>
                </div>
                <div className="radioButton" id="winter" data-id="winter" role = "button" tabIndex='0' onKeyDown={(event) => this.replyClickSec(event)} onClick={(event) => this.replyClickSec(event)}>
                    <div className="radio" ></div>
                        <label htmlFor="winter">
                            <span>Zima</span>
                        </label>
                </div>
            </form>

        )
    }
}

export default SecondRadioButtonsGroup;